import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Scroller} from "primeng/scroller";
import {BasketDto} from "../../../../models/basket-dto";
import { ListboxClickEvent } from 'primeng/listbox';
import { Observable } from 'rxjs';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'locus-basket-list',
  templateUrl: './locus-basket-list.component.html',
  styleUrls: ['./locus-basket-list.component.scss']
})
export class LocusBasketListComponent implements OnInit, OnChanges {
  @ViewChild('scb') scb!: Scroller;
  @Input() currentLanguage!: Observable<string>;
  @Input() selectedBasketId!: number;
  page: number = 0;
  selectedBasket?: BasketDto;
  _locusBasketList: BasketDto[] = [];

  get locusBasketList(): BasketDto[] {
    return this._locusBasketList;
  }

  @Input() set locusBasketList(value: BasketDto[]) {
    const selectedBasket = value.find(basket => basket.isSelected)
    const otherBaskets = value.filter(basket => !basket.isSelected).sort((a, b) => a.basketNo - b.basketNo);
    if(selectedBasket) {
    this.setSelected(selectedBasket);
    }
    
    this._locusBasketList = selectedBasket ? [selectedBasket, ...otherBaskets] : [...otherBaskets];
  }

  ngOnInit() {
    this.selectedBasket = this._locusBasketList.find((e: BasketDto) => e.isSelected) || this._locusBasketList[0];
    this._locusBasketList = this._locusBasketList.map((e: BasketDto) => ({...e, isSelected: e.basketId === this.selectedBasket?.basketId}));
  }

  setSelected(basket: BasketDto) {
    const selectedBasketId = basket.basketId;
    this._locusBasketList = this._locusBasketList.map(basket => ({
      ...basket,
      isSelected: basket.basketId === selectedBasketId
    }));
    this.selectedBasket = basket;
  }

  ngOnChanges(changes: SimpleChanges): void {
  const baskets = changes['locusBasketList']?.currentValue.sort((a: BasketDto, b: BasketDto) => a.basketNo - b.basketNo);
  if (baskets?.length > 0) {
    const check = baskets.findIndex((e: BasketDto) => e.basketNo === this.selectedBasketId);
    if (check !== -1) {
      this.page = (check % 5);
    }
  }
}
}
